export default __webpack_public_path__ + "static/media/group-icon-globe.d82dbe51.svg";